/**
 * Camera Shutter — プリローダー退場 & ページ遷移エフェクト
 */
const shutter = {
  el: null,
  duration: 850, // CSS transition (0.65s) + max stagger (0.15s * 5/6 ≈ 0.125s) + 余裕

  init() {
    this.el = document.querySelector('.shutter');
    if (!this.el) return;

    this._handlePageArrival();
    this._bindLinks();
    this._handleBfCache();
  },

  /** ページ到着時：下層ページは常にシャッター閉→開 */
  _handlePageArrival() {
    // トップページはプリローダーがシャッターを制御するためスキップ
    if (document.querySelector('.preloader')) return;

    sessionStorage.removeItem('shutter-transition');

    // PHP 側で is-closed is-instant を付与済みのため、ここでは開くだけ。
    // is-instant を外してトランジションを有効化し、開く。
    this.el.classList.remove('is-instant');

    const openShutter = () => setTimeout(() => this.open(), 100);
    if (document.readyState === 'complete') {
      openShutter();
    } else {
      window.addEventListener('load', openShutter, { once: true });
    }
  },

  /** 内部リンクをインターセプトしてシャッター遷移 */
  _bindLinks() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;

      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:'))
        return;
      if (a.target === '_blank' || a.hasAttribute('data-shutter-skip')) return;

      try {
        const url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
      } catch {
        return;
      }

      e.preventDefault();
      const dest = href;
      this.close(() => {
        location.href = dest;
      });
    });
  },

  /** シャッターを閉じる（アニメーションあり） */
  close(callback) {
    if (!this.el) {
      callback && callback();
      return;
    }
    this.el.classList.add('is-closed');
    if (callback) setTimeout(callback, this.duration);
  },

  /** シャッターを開く（アニメーションあり） */
  open(callback) {
    if (!this.el) {
      callback && callback();
      return;
    }
    this.el.classList.remove('is-closed');
    if (callback) setTimeout(callback, this.duration);
  },

  /** アニメーション無しで即座にシャッターを閉じる */
  _setInstantClosed() {
    this.el.classList.add('is-instant', 'is-closed');
    this.el.offsetHeight; // force reflow
    this.el.classList.remove('is-instant');
  },

  /**
   * bfcache（ブラウザ戻る/進む）で復元されたとき、
   * シャッターが閉じたまま残るのを防ぐ
   */
  _handleBfCache() {
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && this.el.classList.contains('is-closed')) {
        this.open();
      }
    });
  },
};

export default shutter;
